export enum BroadcastHubMessageGroupEnum {
  Global = 0,
  DriverInfo = 1,
  Telephony = 2,
  OrderImport = 3,
  DeployInspections = 4,
}

export enum BroadcastHubMessageTypeEnum {
  'Ping' = 0,
  'TaskTrackingUpdate' = 1,
  'TaskStarted' = 2,
  'TaskEnded' = 3,
  'OrderImportStatusChange' = 5,
  'OrderImportRowStatusChange' = 7,
  'DeployInspectionStatusChange' = 8,
  'DeployInspectionRowStatusChange' = 9,
}
